import { render, staticRenderFns } from "./PwChange.vue?vue&type=template&id=7a0b92d1"
import script from "./PwChange.vue?vue&type=script&lang=js"
export * from "./PwChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports